@if(status != null) {
<span
    class="status-block"
    [ngClass]="{
        pending: status === 'PENDING' || status === 'BEING_REVIEWED',
        active: status === 'APPROVED',
        inactive: status === 'REJECTED' || status === 'REVOKED',
        disabled: status === 'DRAFT'
    }"
>
    {{ status | titlecase }}
</span>
}
